// "Post Free Times" on a stylist's column in the diary: New post, at free
// slots, for that stylist and the day on screen. Shown only when Social is on
// and this person could open it, as the /marketing-social route decides: the
// owner, anyone whose role includes marketing, or a self-employed stylist
// (on their own column only, since they post their own times). Hidden while
// reception mode hides marketing.
import moment from 'moment'
import { SOCIAL_VISIBLE } from '../../../../../config/featureFlags'
import { getAccess, can, isSelfEmployedMe } from '../../../../permissions/access'

const receptionHidesMarketing = () => {
  try {
    const r = JSON.parse(localStorage.getItem('receptionModeSettings')) || {}
    return !!(r.enabled && r.hiddenAreas && r.hiddenAreas.marketing)
  } catch (e) {
    return false
  }
}

export const canPostFreeTimes = (staffId) => {
  if (!SOCIAL_VISIBLE || !staffId || receptionHidesMarketing()) return false
  try {
    if (isSelfEmployedMe()) return String(staffId) === String(localStorage.getItem('userId') || '')
    return !!getAccess().owner || can('marketing')
  } catch (e) {
    return false
  }
}

// Where it goes, as history.push arguments
export const freeTimesFor = (staff, date) => ['/marketing-social', {
  create: true,
  type: 'freeSlots',
  day: moment(date).toISOString(),
  staffId: String(staff.id),
  staffName: String(staff.name || '').trim(),
}]
